import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import {
  FullHeightContainer,
  StyledPage,
} from '../../app/components/DashboardLayout/DashboardLayout.style';
import { SwingsTableContainer } from '../containers/SwingsTableContainer/SwingsTableContainer';
import { PageHeader } from '../../app/components/DashboardLayout/PageHeader/PageHeader';

export const SwingView: FC = () => {
  return (
    <StyledPage title="Swings">
      <FullHeightContainer maxWidth={false}>
        <Box mb={3}>
          <PageHeader title="Swings" />
        </Box>
        <Box
          flexDirection="column"
          height="100%"
          justifyContent="center"
          flex={1}
        >
          <SwingsTableContainer />
        </Box>
      </FullHeightContainer>
    </StyledPage>
  );
};
